import { useEffect, useState } from 'react'

import { AceEditor } from '@/components/AceEditor/AceEditor'
import { EditorModalHeader } from '@/components/EditorModalHeader'
import { ModalForm } from '@/components/Modal/ModalForm'
import { CopyTextButton } from '@/components/MrtTable/components/CopyTextButton'
import { Input } from '@/components/UberForm/Input/Text/styles'
import { useAppContext } from '@/hooks'

import { CellProps } from './types'

export const ScriptModalCell = ({
	value,
	onChange,
	isDisabled,
	label,
	isEditMode,
}: CellProps) => {
	const { t } = useAppContext()
	const [isModalOpen, setModalOpen] = useState(false)
	const [aceValue, setAceValue] = useState('')

	const onSubmit = () => {
		setModalOpen(false)
		onChange(aceValue)
	}

	useEffect(() => {
		if (value) {
			setAceValue(value)
		}
	}, [value])

	return (
		<>
			<Input
				className="textInputWithoutBorder"
				type="text"
				value={value}
				onClick={() => setModalOpen(true)}
				$compact={false}
				disabled={isDisabled}
				readOnly
			/>

			<ModalForm
				open={isModalOpen}
				onClose={() => setModalOpen(false)}
				onSubmit={onSubmit}
				header={<EditorModalHeader attributeLabel={label} />}
				contentStyle={{ width: '31.25rem' }}
				hasSubmitButton={isEditMode}
				cancelTitle={isEditMode ? t('CANCEL') : t('CLOSE')}
				footerBefore={<CopyTextButton text={aceValue} />}
			>
				<AceEditor
					value={aceValue}
					title={label}
					onChange={(value: string) => {
						setAceValue(value)
					}}
					onKeyPress={({ key, metaKey }) => {
						if (metaKey && key === 'Enter') {
							onSubmit()
						}
					}}
					autoFocus
					height={250}
					disabled={!isEditMode}
				/>
			</ModalForm>
		</>
	)
}
